const FIELD_MAP = {
    "Migration Phase": "No phase found",
    "Migration Products": "Atlassian product",
    "Atlassian Cloud URL": "url not available"
};

type Field = {
    label: keyof typeof FIELD_MAP;
    value: string | null;
};

export const getFieldValue = ({ label, value }: Field) => {
    const unknownValue = FIELD_MAP[label];

    return value ?? unknownValue;
};
